// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8272ae83","455":"125e0d39","977":"eb604df1"}[chunkId] + ".chunk.js";
};